import React, { useEffect, useState } from "react"
import {
  change,
  Field,
  formValueSelector,
  getFormSyncErrors,
  setSubmitFailed,
} from "redux-form"
import { FORM_NAMES } from "constants/index"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { SaveButton } from "components/Buttons"
import { TextField } from "components/RenderInput"
import { connect } from "react-redux"
import ModalComponent from "components/Modals"
import ImageEditor from "components/ImageEditor"
import ColorPicker from "components/ColorPicker"
import { postQuestionnaireDesign } from "store/actions"
import PropTypes from "prop-types"
import QuestionnairePreview from "./questionnairePreview"
import { getFileBlob } from "utils"

const CreateDesign = props => {
  const [isDesignSubmitFailedModalOpen, setIsDesignSubmitFailedModalOpen] =
    useState(false)
  useEffect(() => {
    if (props.questionnaireDesign) {
      props.change(
        "questionnaire_form.createDesign.backgroundColor",
        props.questionnaireDesign.bg_color
      )
      props.change(
        "questionnaire_form.createDesign.buttonBgColor",
        props.questionnaireDesign.button_bg_color
      )
      props.change(
        "questionnaire_form.createDesign.buttonTextColor",
        props.questionnaireDesign.button_font_color
      )
      props.change(
        "questionnaire_form.createDesign.textColor",
        props.questionnaireDesign.font_color
      )
      props.change(
        "questionnaire_form.createDesign.submitText",
        props.questionnaireDesign.submit_text
      )
      props.change("questionnaire_form.createDesign.image", {
        editedImage: props.questionnaireDesign?.image_url,
      })
      props.change("questionnaire_form.createDesign.backgroundImage", {
        editedImage: props.questionnaireDesign?.bg_image_url,
      })
    }
  }, [props.questionnaireDesign])

  const submitHandler = () => {
    if (!props.feature.entity_id) {
      setIsDesignSubmitFailedModalOpen(true)
      return
    }
    if (
      !(
        props.formSyncErrors.hasOwnProperty("questionnaire_form") &&
        props.formSyncErrors?.questionnaire_form.hasOwnProperty("createDesign")
      )
    ) {
      let bgImage = null
      let image = null
      if (props.createDesignFormValue?.backgroundImage?.editedImage) {
        if (
          (props.questionnaireDesign?.bg_image_url &&
            props.createDesignFormValue?.deleteBgImage) ||
          !props.questionnaireDesign?.bg_image_url
        ) {
          bgImage = {
            vendor_id: props.vendorId,
            dir: "background",
            user_id: props.userId,
            files: [
              getFileBlob(
                props.createDesignFormValue?.backgroundImage?.editedImage
              ),
            ],
          }
        }
      }
      if (props.createDesignFormValue?.image?.editedImage) {
        if (
          (props.questionnaireDesign?.image_url &&
            props.createDesignFormValue?.deleteImage) ||
          !props.questionnaireDesign?.image_url
        ) {
          image = {
            vendor_id: props.vendorId,
            dir: "background",
            user_id: props.userId,
            files: [
              getFileBlob(props.createDesignFormValue?.image?.editedImage),
            ],
          }
        }
      }
      props.postQuestionnaireDesign({
        bgImage,
        image,
        design: {
          bg_color: props.createDesignFormValue?.backgroundColor,
          button_bg_color: props.createDesignFormValue?.buttonBgColor,
          button_font_color: props.createDesignFormValue?.buttonTextColor,
          font_color: props.createDesignFormValue?.textColor,
          questionnaire_id: props.questionnaire.id,
          submit_text: props.createDesignFormValue?.submitText,
          vendor_id: props.vendorId,
          // bg_image_url: props.questionnaireDesign?.bg_image_url || null,
          // image_url: props.questionnaireDesign?.image_url || null,
          id: props.questionnaireDesign?.id || null,
          ...(props?.createDesignFormValue?.deleteImage ? {delete_image: 1} : {}), 
          ...(props?.createDesignFormValue?.deleteBgImage ? {delete_bg_image: 1} : {}), 
        },
      })
    } else {
      props.setSubmitFailed(["questionnaire_form.createDesign"])
    }
  }
  return (
    <>
      <Card>
        <CardBody>
          <Row className="mb-3">
            <Col>
              <h3>Design</h3>
            </Col>
            <Col xs="auto" className="mx-3">
              <SaveButton
                content="Save"
                type="button"
                onClick={submitHandler}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Card>
                <CardHeader>
                  <h4>SET DESIGN</h4>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col>
                      <Field
                        name="backgroundImage"
                        component={ImageEditor}
                        onDelete={() => {
                          props.change(
                            "questionnaire_form.createDesign.deleteBgImage",
                            true
                          )
                        }}
                        label="Background Image"
                      />
                    </Col>
                  </Row>
                  <Row className="my-3">
                    <Col>
                      <Field
                        name="image"
                        component={ImageEditor}
                        onDelete={() => {
                          props.change(
                            "questionnaire_form.createDesign.deleteImage",
                            true
                          )
                        }}
                        label="Image"
                      />
                    </Col>
                  </Row>
                  <Row className="my-3">
                    <Col>
                      <Field
                        name="backgroundColor"
                        component={ColorPicker}
                        label="Background Color"
                      />
                    </Col>
                  </Row>
                  <Row className="my-3">
                    <Col>
                      <Field
                        name="textColor"
                        component={ColorPicker}
                        label="Text Color"
                      />
                    </Col>
                  </Row>
                  <Row className="my-3">
                    <Col>
                      <Field
                        name="buttonBgColor"
                        component={ColorPicker}
                        label="Button Background Color"
                      />
                    </Col>
                  </Row>
                  <Row className="my-3">
                    <Col>
                      <Field
                        name="buttonTextColor"
                        component={ColorPicker}
                        label="Button Text Color"
                      />
                    </Col>
                  </Row>
                  <Row className="my-3">
                    <Col>
                      <Field
                        name="submitText"
                        component={TextField}
                        label="Submit Text"
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Row className="my-2">
                <Col className="d-flex justify-content-center">
                  <SaveButton
                    content="Save"
                    type="button"
                    onClick={submitHandler}
                  />
                </Col>
              </Row>
            </Col>
            <Col xl={4} className="mt-4 custom-features-preview">
              <QuestionnairePreview
                menu_bg_color={props.design?.menu_bg_color}
                menu_font_color={props.design?.menu_font_color}
                label={props.feature?.label}
                headline={props.formValues?.create?.headline}
                subtext={props.formValues?.create?.subtext}
                bgImage={
                  props.formValues?.createDesign?.backgroundImage?.editedImage
                }
                image={props.formValues?.createDesign?.image?.editedImage}
                bgColor={props.formValues?.createDesign?.backgroundColor}
                textColor={props.formValues?.createDesign?.textColor}
                buttonBgColor={props.formValues?.createDesign?.buttonBgColor}
                buttonTextColor={
                  props.formValues?.createDesign?.buttonTextColor
                }
                submitText={props.formValues?.createDesign?.submitText}
                questions={props.formValues?.create?.questions}
              />
            </Col>
          </Row>
        </CardBody>
      </Card>
      <ModalComponent
        title={"Unable to store design"}
        open={isDesignSubmitFailedModalOpen}
        onClose={() => {
          setIsDesignSubmitFailedModalOpen(false)
        }}
      >
        <Row>
          <h5>
            Before saving the design, you need to actually create the
            questionnaire.
          </h5>
        </Row>
        <Row className="mt-3">
          <Col>
            <SaveButton
              type="button"
              fullWidth={true}
              content="Ok"
              onClick={() => {
                setIsDesignSubmitFailedModalOpen(false)
              }}
            />
          </Col>
        </Row>
      </ModalComponent>
    </>
  )
}

const selector = formValueSelector(FORM_NAMES.QUESTIONNAIRE)

const mapStateToProps = state => ({
  createDesignFormValue: selector(state, "questionnaire_form.createDesign"),
  formSyncErrors: getFormSyncErrors(FORM_NAMES.QUESTIONNAIRE)(state),
  selectedEvent: state.experiences.selectedEvent,
  vendorId: state.Login.vendorId,
  userId: state.Login.authUser.id,
  questionnaireDesign: state.Questionnaire.questionnaireDesign,
  questionnaire: state.Questionnaire.questionnaire,
  formValues: selector(state, "questionnaire_form"),
})

const mapDispatchToProps = dispatch => ({
  setSubmitFailed: fields =>
    dispatch(setSubmitFailed(FORM_NAMES.QUESTIONNAIRE, ...fields)),
  change: (field, value) =>
    dispatch(change(FORM_NAMES.QUESTIONNAIRE, `${field}`, value)),
  postQuestionnaireDesign: values => dispatch(postQuestionnaireDesign(values)),
})

CreateDesign.propTypes = {
  feature: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateDesign)
